export interface ListEntry {
  name: string;
  path: string;
  isDir: boolean;
  isSymlink?: boolean;
}

/** Yield while resolving entries in large directories. */
export const LIST_DIR_YIELD_EVERY = 256;
